<div class="experience-scope" [attr.data-theme]="theme">
  <div class="home-experience">
    <header class="home-experience__topbar">
      <div class="logo-mark" title="Cimalti">
        <img src="../../../assets/images/logo-min-white.svg" alt="Cimalti" />
      </div>
      <div class="home-experience__brand">
        <div class="home-experience__brand-name">Cimalti</div>
        <div class="home-experience__brand-sub">Portfolios · 2026</div>
      </div>
      <div class="home-experience__spacer"></div>
      <button
        class="btn btn-ghost btn-sm"
        type="button"
        (click)="goToReports()"
        title="Open research library"
      >
        <svg
          viewBox="0 0 24 24"
          width="14"
          height="14"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linejoin="round"
        >
          <path d="M6 3h9l4 4v14H6z" />
          <path d="M15 3v4h4" />
          <path d="M9 13h6M9 16h4M9 19h6" stroke-linecap="round" />
        </svg>
        <span>Research library</span>
      </button>
      <button
        class="btn btn-ghost btn-sm exit-btn"
        type="button"
        (click)="exitExperience()"
        title="Exit editorial view"
      >
        <svg
          viewBox="0 0 24 24"
          width="14"
          height="14"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
        >
          <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
          <path d="M16 17l5-5-5-5" />
          <path d="M21 12H9" />
        </svg>
        <span>Exit</span>
      </button>
      <button
        class="icon-btn"
        type="button"
        (click)="toggleTheme()"
        [title]="theme === 'dark' ? 'Switch to light' : 'Switch to dark'"
      >
        @if (theme === "dark") {
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            width="17"
            height="17"
          >
            <path d="M21 13a9 9 0 11-10-10 7 7 0 0010 10z" />
          </svg>
        }
        @if (theme === "light") {
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            width="17"
            height="17"
          >
            <circle cx="12" cy="12" r="4" />
            <path
              d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"
            />
          </svg>
        }
      </button>
    </header>

    <div class="home-wrap">
      <div class="ask-box">
        <svg
          class="spark-ico"
          viewBox="0 0 24 24"
          width="20"
          height="20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            d="M12 2L13.8 8.2L20 10L13.8 11.8L12 18L10.2 11.8L4 10L10.2 8.2z"
          />
        </svg>
        <input
          type="text"
          [(ngModel)]="askValue"
          (keydown.enter)="submitAsk()"
          placeholder="Ask Cimalti AI anything — e.g. 'Which portfolios need rebalancing?'"
        />
        <button
          class="ask-send"
          type="button"
          (click)="submitAsk()"
          aria-label="Send"
        >
          <svg viewBox="0 0 24 24"><path d="M5 12h14M13 5l7 7-7 7" /></svg>
        </button>
      </div>

      <div class="suggest-row">
        <div class="suggest-main">
          @for (s of suggestionsMain; track s) {
            <button
              class="suggest-chip"
              type="button"
              (click)="onSuggestClick(s)"
            >
              <span class="em">{{ s.emoji }}</span> {{ s.label }}
            </button>
          }
        </div>
        <div class="suggest-actions">
          @for (s of suggestionsActions; track s) {
            <button
              class="suggest-chip suggest-chip--action"
              type="button"
              (click)="onSuggestClick(s)"
            >
              <span class="em">{{ s.emoji }}</span> {{ s.label }}
            </button>
          }
        </div>
      </div>

      <h1 class="home-greet">
        {{ greeting }}
        @if (userName) {
          , {{ userName }}
        }
      </h1>
      <p class="home-sub">
        Here is what happened with your portfolios since your last visit.
      </p>

      <div class="feed-head">
        <div class="feed-head-left">
          <div class="title">Portfolio updates</div>
          <div class="meta">
            Showing {{ feed.length }} of {{ feedTotal }} portfolios
          </div>
        </div>
        <div class="feed-head-right">
          <a
            class="see-all-btn"
            (click)="goToAllPortfolios()"
            style="cursor: pointer"
            >See all portfolios →</a
          >
        </div>
      </div>

      @if (!isLoading && feed.length) {
        <div class="feed">
          @for (p of feed; track trackByFeed($index, p)) {
            <a class="pf-card" (click)="onCardClick(p)" style="cursor: pointer">
              <div class="pf-body">
                <div class="pf-when">{{ p.when }}</div>
                <div class="title-row">
                  <span class="pf-name">{{ p.name }}</span>
                  <span class="headline-pill" [ngClass]="p.headline.tone">
                    <span class="arrow">{{ p.arrow }}</span>
                    {{ p.headline.label }} {{ p.metricText }}
                  </span>
                </div>
                <p [innerHTML]="p.summary"></p>
              </div>
              <div class="pf-metric" [ngClass]="p.headline.tone">
                <div class="mlbl">{{ p.headline.label }}</div>
                <div class="mval">{{ p.metricText }}</div>
              </div>
              <div class="pf-chart">
                <div class="pf-chart-cap">{{ p.caption }}</div>
                <div class="pf-chart-body">
                  <app-exp-home-mini
                    [kind]="p.headline.kind"
                    [series]="p.series"
                    [weights]="p.weights"
                    [color]="p.chartColor"
                    [loading]="p.isLoadingSeries"
                  ></app-exp-home-mini>
                </div>
              </div>
            </a>
          }
        </div>
      }

      @if (!isLoading && hasMorePortfolios) {
        <div class="feed-load-more">
          <button
            type="button"
            class="feed-load-more-btn"
            (click)="onLoadMore()"
            [disabled]="isLoadingMore"
          >
            @if (!isLoadingMore) {
              <span>
                Load more portfolios
                <span class="feed-load-more-count"
                  >({{ remainingPortfolioCount }} remaining)</span
                >
              </span>
            }
            @if (isLoadingMore) {
              <span>Loading…</span>
            }
          </button>
        </div>
      }

      @if (isLoading) {
        <div class="home-experience__state">
          <div
            class="shimmer"
            style="
              width: 100%;
              height: 140px;
              border-radius: 14px;
              margin-bottom: 10px;
            "
          ></div>
          <div
            class="shimmer"
            style="width: 100%; height: 140px; border-radius: 14px"
          ></div>
        </div>
      }

      @if (!isLoading && hasError) {
        <div class="home-experience__state home-experience__state--error">
          Couldn't load portfolios. Try again in a moment.
        </div>
      }

      @if (!isLoading && !hasError && !feed.length) {
        <div class="home-experience__state">
          No portfolios yet. Create one to start the editorial workflow.
        </div>
      }
    </div>
  </div>

  <app-exp-pdf-drop
    [open]="pdfDropOpen"
    (close)="closeUpload()"
    (uploaded)="onUploaded($event)"
  ></app-exp-pdf-drop>
</div>
